exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".author-books__books{display:flex;flex-wrap:wrap}.author-books__book{margin-bottom:20px;text-align:center;width:50%}.author-books__book:nth-child(2n){padding-left:10px}.author-books__book:nth-child(2n+1){padding-right:10px}.author-books__book--single{width:auto}.author-books__book__cover{display:block}.author-books__book__title{font-size:16px;font-size:1rem;margin-top:10px}.author-books__book__figure{overflow:visible}.author-books__book__alacarte-badge{left:-18px;position:absolute;top:-18px}\n", ""]);

// exports
exports.locals = {
	"author-books__books": "author-books__books",
	"author-books__book": "author-books__book",
	"author-books__book--single": "author-books__book--single",
	"author-books__book__cover": "author-books__book__cover",
	"author-books__book__title": "author-books__book__title",
	"author-books__book__figure": "author-books__book__figure",
	"author-books__book__alacarte-badge": "author-books__book__alacarte-badge"
};